import * as React from 'react';
import { serviceLocator } from './../../services';
import { Websites as WebsitesInner } from './../../components/Websites';
import { Breadcumb } from '../../components/Breadcumb';

const service = serviceLocator.getWebsiteService();
const uiService = serviceLocator.getUIService();

export class Websites extends React.Component<{}, {}>{

    render() {
        const agency = uiService.getSelectedAgency();
        return (
            <WebsitesInner
                showAgencyTags={!agency}
                agency={agency}
                themeKey="custom-website"
                title={<Breadcumb items={[
                    { label: `Custom Website` },
                ]} />}
                buildWebsite={service.buildWebsite}
                syncWebsite={(key: string) => service.syncWebsiteBucket(key, true)}
                listWebsites={(agency: string, status: string) => service.listWebsites(agency, 'custom-website', status)}
                listWebsitesExtended={(agency) => service.listWebsitesExtended(agency, 'custom-website')}
                renameWebsite={service.renameWebsite}
                deleteWebsite={service.deleteWebsite}
                createNewWebsite={service.createNewWebsite}
                cloneWebsite={service.cloneWebsite}
                setWebsiteAsPreConfigured={service.setWebsiteAsPreConfigured}
                listPreConfigureds={() => service.listPreConfigureds(agency, 'custom-website')}
            />
        );
    }
}